<template>
  <div class="ma-4 app">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row v-for="item in 2" :key="`item-${item}`">
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row v-for="item in 4" :key="`image-${item}`">
        <v-col>
          <v-skeleton-loader class="mx-auto" type="image" />
        </v-col>
      </v-row>
    </v-sheet>

    <v-form v-show="!showSkeleton" ref="form">
      <div class="text-h4" v-if="edicao === 'false' || !edicao">
        Cadastro de Perfil
      </div>

      <v-card class=" my-6 px-6" elevation="1" outlined>
        <v-row>
          <v-col cols="6" class="mt-4">
            <v-text-field
              dense
              v-model="form.description"
              counter="30"
              :disabled="permissaoVisualizar"
              :error-messages="descriptionErrors"
              label="Descrição do Perfil"
              outlined
              @input="
                $v.form.description.$touch();
                form.description = $event.toUpperCase().trim();
              "
              @blur="$v.form.description.$touch()"
            />
          </v-col>
        </v-row>
      </v-card>

      <v-card class=" my-6 px-8 py-4" elevation="1" outlined>
        <ModuloPABXStep />
      </v-card>
      <v-card class=" my-6 py-4 px-8" elevation="1" outlined>
        <ModuloRelatoriosPABXStep />
      </v-card>
      <v-card class=" my-6 py-4 px-8" elevation="1" outlined>
        <ModuloMonitorRamaisStep />
      </v-card>
      <v-card class=" my-6  py-4 px-8" elevation="1" outlined>
        <ModuloCentralAtendimentoStep />
      </v-card>
      <v-card class=" my-6 py-4 px-8" elevation="1" outlined>
        <ModuloPesquisaSatisfacaoStep />
      </v-card>
      <v-card class="mt-6 mb-12 py-4 px-8" elevation="1" outlined>
        <ModuloUsuariosStep />
      </v-card>

      <FixedButtons
        @salvar="salvar"
        @cancelar="cancelar"
        :pararLoader="pararLoader"
        :disableSaveButton="permissaoVisualizar"
      />
    </v-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";

import { registerVuexModule } from "@/utils/vuexUtils";
import FixedButtons from "@/componentes/FixedButtons";
import Snackbar from "@/componentes/Snackbar";
import { obtainUserPermissions } from "@/utils/obtainUserPermissions";

import { validateData, validateComputed } from "../_validates/validatesForm";
import perfisHttpService from "../_services/perfisHttpService";
import perfisStore from "../_store";
import { generatePermissionsForRoleMethod } from "../_utils/generatePermissionsForRoleMethod";
import { insertRightPermissionsOnSelectedRole } from "../_utils/insertRightPermissionsOnSelectedRole";

import ModuloPABXStep from "../_components/ModuloPABXStep";
import ModuloRelatoriosPABXStep from "../_components/ModuloRelatoriosPABXStep";
import ModuloMonitorRamaisStep from "../_components/ModuloMonitorRamaisStep";
import ModuloCentralAtendimentoStep from "../_components/ModuloCentralAtendimentoStep";
import ModuloPesquisaSatisfacaoStep from "../_components/ModuloPesquisaSatisfacaoStep";
import ModuloUsuariosStep from "../_components/ModuloUsuariosStep";

export default {
  name: "CadastroPerfil",
  props: {
    edicao: String,
    id: String,
  },
  components: {
    FixedButtons,
    ModuloPABXStep,
    ModuloRelatoriosPABXStep,
    ModuloMonitorRamaisStep,
    ModuloCentralAtendimentoStep,
    ModuloPesquisaSatisfacaoStep,
    ModuloUsuariosStep,
    Snackbar,
  },
  mixins: [validationMixin],
  data: () => ({
    showSkeleton: false,
    snackbar: false,
    text: "",
    form: {
      description: "",
      permissions: [],
      agentesPermitidos_ids: [],
      queuesPermitidos_ids: [],
      departamentosPermitidos_ids: [],
      tagsPesquisaPermitidos_ids: [],
      tagsRelatorioPabxPermitidos_ids: [],
      conferenciasPermitidos_ids: [],
      pesquisasPermitidos_ids: [],
      ramaisMonitorRamaisPermitidos_ids: [],
      ramaisRelatoriosPabxPermitidos_ids: [],
      rolesPermitidos_ids: [],
    },
    pararLoader: {
      parar: false,
    },
    permissaoVisualizar: false,
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters("moduloPABXStepStore", [
      "getSpecificRole",
      "getSelectedRamaisRelatoriosPABX",
      "getSelectedRamaisMonitorRamais",
      "getSelectedTagsRelatoriosPABX",
      "getSelectedTagsPesquisaSatisfacao",
      "getSelectedConferencias",
      "getSelectedOperadores",
      "getSelectedFilas",
      "getSelectedDepartamentos",
      "getSelectedPesquisasSatisfacao",
      "getSelectedRoles",
      "getPermissoes",
    ]),
    ...validateComputed,
  },

  async created() {
    this.showSkeleton = true;
    registerVuexModule(this.$store, "moduloPABXStepStore", perfisStore);

    await this.resetarConfiguracoesPerfil();

    if (this.edicao === "true") {
      this.form.description = this.getSpecificRole.name;
      await this.insertRightPermissionsOnSelectedRole();
    }

    const arrayPermissions = this.arrayPermissionsFromLocalStorage();
    if (
      arrayPermissions.includes(
        process.env.VUE_APP_USUARIOS_CADASTRO_PERFIL_VISUALIZAR
      )
    ) {
      this.permissaoVisualizar = true;
    }

    this.showSkeleton = false;
  },

  methods: {
    ...mapActions("moduloPABXStepStore", [
      "resetarConfiguracoesPerfil",
      "setSelectedRamaisRelatoriosPABX",
      "setSelectedRamaisMonitorRamais",
      "setSelectedTagsRelatoriosPABX",
      "setSelectedTagsPesquisaSatisfacao",
      "setSelectedConferencias",
      "setSelectedFilas",
      "setSelectedDepartamentos",
      "setSelectedOperadores",
      "setSelectedPesquisasSatisfacao",
      "setSelectedRoles",
      "addPermissionsID",
      "changeAllPermissionsID",
    ]),
    ...generatePermissionsForRoleMethod,
    ...insertRightPermissionsOnSelectedRole,
    ...obtainUserPermissions,

    async salvar() {
      this.pararLoader.parar = false;
      this.mountRolePermissionsAndSelects();
      this.$v.$touch();
      if (this.$v.$error) {
        console.log(this.$v);
        this.$vuetify.goTo(1, { duration: 1000, easing: "easeOutCubic" });
        this.pararLoader.parar = true;

        if (this.form.description === "" || this.form.description.length > 30) {
          this.snackbar = true;
          this.text = "Corrija a descrição";
        }

        if (this.getPermissoes.length === 0) {
          this.snackbar = true;
          this.text = "Adicione ao menos uma permissão";
        }
        return;
      }

      try {
        if (this.edicao === "true") {
          await perfisHttpService.putRoles(this.id, this.form);
          this.changeAllPermissionsID([]);
        } else {
          await perfisHttpService.postRoles(this.form);
          console.log(this.form);
          this.changeAllPermissionsID([]);
        }
        this.$router.push({ name: "Perfil" });
      } catch (e) {
        console.error(e.response.data.message, "ERROR RESPONSE");
        this.pararLoader.parar = true;
        this.snackbar = true;
        this.text = e.response.data.message;
      }
    },

    cancelar() {
      this.changeAllPermissionsID([]);
      this.$router.push({ name: "Perfil" });
    },
  },
};
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
